import { Result } from "@/shared/types";

export type ApiError = {
    status: number;
    message: string;
    errors: Record<string, string[]>;
};

export type ApiResult<T> = Result<T, ApiError>;

export type ApiOptions = {
    params?: Record<string, unknown>;
    headers?: Record<string, string>;
    signal?: AbortSignal;
};

// ==================== RESULT HELPERS ====================

export const ok = <T>(data: T): ApiResult<T> => ({
    success: true,
    data,
    error: null,
});

export const err = (error: ApiError): ApiResult<never> => ({
    success: false,
    data: null,
    error,
});

export const isOk = <T, E>(result: Result<T, E>): result is { success: true; data: T; error: null } =>
    result.success === true;

export const isErr = <T, E>(result: Result<T, E>): result is { success: false; data: null; error: E } =>
    result.success === false;

// ==================== CONTEXT ====================

export type RetryableRequest = Request & { isRetry?: boolean }


export type ResponseContext = {
    request: RetryableRequest;
    response: Response;
};


export type RequestMiddleware = (
    request: RetryableRequest,
    next: (req: RetryableRequest) => Promise<RetryableRequest>
) => Promise<RetryableRequest>;

export type ResponseMiddleware = (
    ctx: ResponseContext,
    next: (ctx: ResponseContext) => Promise<ResponseContext>
) => Promise<ResponseContext>;

export enum HttpStatusCode {
    BadRequest = 400,
    Unauthorized = 401,
    PaymentRequired = 402,
    Forbidden = 403,
    NotFound = 404
}

